const GTM = {
  init: () => {
    const interval = setInterval(() => {
      if ("dataLayer" in window && "google_tag_manager" in window) {
        window.dataLayer.push({ event: "gatsby-route-change" });
        clearInterval(interval);
      }
    }, 100);
  },

  // form tags START
  formSubmission: (formName) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({ event: "formCompletion", formName });
    }
  },
  formInputChange: (formName, fieldName, fieldValue) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "inputChange",
        formName,
        fieldName,
        ...(fieldValue && { fieldValue }),
      });
    }
  },
  formInputError: (fieldName, fieldError, formName) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "inputError",
        fieldName,
        fieldError,
        formName,
      });
    }
  },
  formInputErrorFormSubmitted: (formName, fieldValue) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "formInputErrorFormSubmitted",
        formName,
        fieldValue,
      });
    }
  },
  errorPage: (code) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: code,
      });
    }
  },
  // form tags END

  // Video tracking START
  videoStart: (title) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "video_start",
        videoTitle: title,
      });
    }
  },

  videoEnd: (title) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "video_ended",
        videoTitle: title,
      });
    }
  },

  videoProgress: (data, title, getDuration) => {
    if ("dataLayer" in window) {
      const currentTime = Math.floor(data.playedSeconds);
      const percentage = Math.floor((currentTime / getDuration()) * 100);

      // Log time intervals (every 10 seconds) only once
      if (
        currentTime % 10 === 0 &&
        currentTime > 0 &&
        !GTM.loggedTimes.has(currentTime)
      ) {
        GTM.loggedTimes.add(currentTime);
        window.dataLayer.push({
          event: "video_timeupdate",
          videoTitle: title,
          videoTime: currentTime.toString(),
        });
      }

      // Log percentage in increments of 10
      const roundedPercentage = Math.floor(percentage / 10) * 10;
      if (!GTM.loggedPercentages.has(roundedPercentage)) {
        GTM.loggedPercentages.add(roundedPercentage);
        if (roundedPercentage === 0) return;

        window.dataLayer.push({
          event: "video_percentage",
          videoTitle: title,
          videoPercentage: roundedPercentage.toString(),
        });
      }
    }
  },

  loggedTimes: new Set(),
  loggedPercentages: new Set(),
  // Video tracking END

  reset: () => {
    GTM.loggedTimes.clear();
    GTM.loggedPercentages.clear();
  },
};

export default GTM;
